import React from "react"

import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

import Grid from "@mui/material/Grid"
import { Button, Snackbar } from "@synapse-analytics/synapse-ui"

type PropType = {
  id: string
  modelId?: string
}

/**
 * Alert to be used when the user creates a classification project / model but has not configured it yet.
 * @param props
 * @constructor
 */
export function KonanClassificationAlert(props: Readonly<PropType>): React.ReactElement {
  const { id, modelId } = props
  const navigate = useNavigate()
  const { t } = useTranslation("status")

  // Alert shown at all project screens
  // when the live model settings hasn't been configured yet
  return (
    <Grid
      item
      container
      alignItems={"center"}
      flexWrap={"nowrap"}
      gap={2}
      width={"100%"}
      justifyContent={"space-between"}
    >
      <Grid item>
        <Snackbar severity={"error"} description={t("classificationAlert.notConfigured.description")} />
      </Grid>
      <Button
        variant="primary"
        size="regular"
        onClick={() => navigate(`/projects/${id}/models/configurations${modelId ? `?model_id=${modelId}` : ""}`)}
      >
        {t("classificationAlert.notConfigured.action")}
      </Button>
    </Grid>
  )
}
